import React, { useState } from 'react'
import { ErrorResponse, Dependence } from '../interfaces/type'
type Props = {
    error: ErrorResponse | null
    handleModalAdd: () => void
    handleAddDependenceSubmit: (data: Partial<Dependence>) => void
}

const AddDependenceModal = ({ handleModalAdd, handleAddDependenceSubmit, error }: Props) => {
    const [values, setValues] = useState<Partial<Dependence>>({ name: '', place: '', to: '', address: '' })

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { value, name } = e.target;
        setValues({
            ...values,
            [name]: value
        })
    }

    const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        handleAddDependenceSubmit(values)
    }

    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-full my-6 mx-auto md:max-w-xl">
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                            <h3 className="text-xl font-semibold">
                                Nueva Dependencia
                            </h3>
                            <button
                                onClick={handleModalAdd}
                                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                            >
                                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                </span>
                            </button>
                        </div>
                        <div className="relative p-6 flex-auto">
                            <div>
                                <label className="block mb-2 text-sm font-medium text-gray-900">Lugar</label>
                                <input type="text" name="place" value={values.place} onChange={handleOnChange}
                                    className="
                                        bg-gray-50 
                                        border 
                                        border-gray-300 
                                        text-gray-900 
                                        text-sm
                                        block 
                                        w-full 
                                        p-2
                                        "
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-medium text-gray-900">Dependencia</label>
                                <input name="name" value={values.name} onChange={handleOnChange}
                                    className="
                                        bg-gray-50 
                                        border 
                                        border-gray-300 
                                        text-gray-900 
                                        text-sm
                                        block 
                                        w-full 
                                        p-2
                                        "
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-medium text-gray-900">Dirigido a</label>
                                <input type="text" name="to" value={values.to} onChange={handleOnChange}
                                    className="
                                        bg-gray-50 
                                        border 
                                        border-gray-300 
                                        text-gray-900 
                                        text-sm
                                        block 
                                        w-full 
                                        p-2
                                        "
                                />
                            </div>
                            <div>
                                <label className="block mb-2 text-sm font-medium text-gray-900">Dirección</label>
                                <input type="text" name="address" value={values.address} onChange={handleOnChange}
                                    className="
                                        bg-gray-50 
                                        border 
                                        border-gray-300 
                                        text-gray-900 
                                        text-sm
                                        block 
                                        w-full 
                                        p-2
                                        "
                                />
                            </div>
                        </div>
                        {/*footer*/}
                        <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                            <button
                                onClick={handleModalAdd}
                                className="text-red-500 background-transparent font-bold uppercase px-5 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                type="button"
                            >
                                Cerrar
                            </button>
                            <button
                                onClick={handleSubmit}
                                className="bg-green-500 text-white hover:bg-green-700 font-bold uppercase text-sm px-5 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                type="button"
                            >
                                Guardar
                            </button>
                        </div>
                        {
                            error &&
                            <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                                <div>{`${error.error}: ${error.errorDetail}`}</div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}

export default AddDependenceModal